import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockOn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 1C13.5913 1 15.117 1.63259 16.2422 2.75781C17.3674 3.88303 18 5.4087 18 7V10H19C20.6569 10 22 11.3431 22 13V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V13C2 11.3431 3.34315 10 5 10H6V7C6 5.4087 6.63259 3.88303 7.75781 2.75781C8.88303 1.63259 10.4087 1 12 1ZM5 12C4.44772 12 4 12.4477 4 13V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V13C20 12.4477 19.5523 12 19 12H5ZM12 3C10.9391 3 9.92202 3.42173 9.17188 4.17188C8.42173 4.92202 8 5.93913 8 7V10H16V7C16 5.93913 15.5783 4.92202 14.8281 4.17188C14.078 3.42173 13.0609 3 12 3Z",
		fill: "white"
	})
});
export default SvgLockOn;
